<template>
    <div id="configDiv" class="vs-con-loading__container">
        <vx-card title="System Config">
            <div class="vx-row">
                <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mt-6">
                    <h4>DRM</h4>
                    <vs-divider/>
                    <p class="mt-6">DRM Signing key</p>
                    <vs-input class="w-full" v-model="config['drm_signing_key']"/>
                    <p class="mt-6">DRM Signing IV</p>
                    <vs-input class="w-full" v-model="config['drm_signing_iv']"/>
                    <p class="mt-6">DRM Key server</p>
                    <vs-input class="w-full" v-model="config['drm_key_server']"/>
                    <p class="mt-6">DRM License server</p>
                    <vs-input class="w-full" v-model="config['drm_license_server']"/>
                    <p class="mt-6">DRM Signer</p>
                    <vs-input class="w-full" v-model="config['drm_signer']"/>
                    <p class="mt-6">DRM DRMToday Shared secret</p>
                    <vs-input class="w-full" v-model="config['drm_drmToday_shared_secret']"/>
                </div>
            </div>
            <vs-divider/>
            <vs-button @click="saveConfig">Save</vs-button>
        </vx-card>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                config: {},
            }
        },
        methods: {
            loadData(){
                this.$vs.loading({
                    container: '#configDiv',
                    type: 'corners',
                    scale: 0.7
                })
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/system_config')
                loadPromise.then(function(response) {
                    thisIns.config = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function () {
                    thisIns.$vs.loading.close('#configDiv > .con-vs-loading')
                })
            },
            saveConfig() {
                this.$vs.loading({
                    container: '#configDiv',
                    type: 'corners',
                    scale: 0.7
                })
                const thisIns = this
                const loadPromise = this.$http.put('/api/management/v1/system_config/', this.config)
                loadPromise.then(function() {
                    thisIns.$printSuccess("Config saved")
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function () {
                    thisIns.$vs.loading.close('#configDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        },
    }

</script>
